import { render, staticRenderFns } from "./ListPointsOrder.vue?vue&type=template&id=149048e9&"
import script from "./ListPointsOrder.vue?vue&type=script&lang=js&"
export * from "./ListPointsOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports